import React from 'react';
import { Button, Tooltip } from 'antd';

interface IProps{
  click:()=>void
}
export const RefreshButton:React.FC<IProps> = ({ click }) => (
  <Tooltip title="Refresh">
    <Button
      onClick={click}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px',
        backgroundColor: '#F7F8FA',
        borderColor: '#190952',
      }}
      icon={(
        <svg width="20" height="20" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 5.9998H5.101L5.102 5.9908C5.23367 5.35178 5.48914 4.7447 5.854 4.2038C6.39829 3.40147 7.16203 2.77277 8.054 2.3928C8.35733 2.26414 8.67 2.16714 8.992 2.1018C9.65795 1.96739 10.344 1.96739 11.01 2.1018C11.9665 2.29912 12.8443 2.77226 13.535 3.4628L14.951 2.0508C14.3134 1.41174 13.5582 0.902048 12.727 0.549802C12.3031 0.37092 11.8627 0.234259 11.412 0.141802C10.4818 -0.0466164 9.52322 -0.0466164 8.593 0.141802C8.14195 0.234519 7.70115 0.371516 7.277 0.550802C6.02753 1.08091 4.95793 1.96089 4.197 3.0848C3.68539 3.84293 3.32731 4.69396 3.143 5.5898C3.115 5.7248 3.1 5.8628 3.08 5.9998H0L4 9.9998L8 5.9998ZM12 7.9998H14.899L14.898 8.0078C14.6363 9.2894 13.8809 10.4166 12.795 11.1458C12.2554 11.513 11.6478 11.7687 11.008 11.8978C10.3424 12.0321 9.65663 12.0321 8.991 11.8978C8.35197 11.7661 7.7449 11.5107 7.204 11.1458C6.93836 10.9666 6.69055 10.7624 6.464 10.5358L5.05 11.9498C5.68799 12.5886 6.44354 13.098 7.275 13.4498C7.699 13.6298 8.142 13.7668 8.59 13.8578C9.5199 14.0461 10.4781 14.0461 11.408 13.8578C13.2006 13.4859 14.7774 12.4293 15.803 10.9128C16.314 10.1552 16.6717 9.30487 16.856 8.4098C16.883 8.2748 16.899 8.1368 16.919 7.9998H20L16 3.9998L12 7.9998Z" fill="black" />
        </svg>
      )}
    />
  </Tooltip>
);
